export const FIND_COUPOM_DISCOUNT = "FIND_COUPOM_DISCOUNT"
export const FIND_COUPOM_DISCOUNT_SUCCESS = "FIND_COUPOM_DISCOUNT_SUCCESS"

export const FIND_COUPOM_DISCOUNT_API_ERROR = "FIND_COUPOM_DISCOUNT_API_ERROR"
